<template>
  <RouterLink
    class="card-template"
    :style="
      imagePath
        ? {
            backgroundImage: `
        var(--gradient-black),
        url(${$baseUrl}images/${imagePath}.webp)
        `,
          }
        : {}
    "
    :to="routeObj"
    @mouseenter="toggeHovered"
    @mouseleave="toggeHovered"
  >
    <div class="card-template__content">
      <slot></slot>
    </div>

    <div class="card-template__discover">
      {{ $t("general.ctas.discover") }}
    </div>
  </RouterLink>
</template>

<script setup>
import { inject, ref } from "vue";
import { pushData } from "@/utilities/analytics-functions.js";

const props = defineProps({
  imagePath: {
    type: String,
  },
  routeObj: Object,
});

const emit = defineEmits(["onClick"]);

const $baseUrl = inject("$baseUrl");
const hovered = ref(false);

function toggeHovered() {
  if (props.cta) {
    hovered.value = !hovered.value;
  }
}

function onClick() {
  if (props.url) {
    if (props.url.includes(".pdf")) {
      pushData("pdf", props.url, "", props.cta);
    }
  } else {
    emit("onClick");
  }
}
</script>

<style lang="scss" scoped>
.card-template {
  width: 100%;
  background-position: 50%;
  aspect-ratio: 0.82;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  background-size: 100%;
  text-align: left;
  position: relative;
  border-radius: toRem(24);
  color: var(--color-white);
  transition: background-size 0.5s;

  &:hover {
    @include elevation-hover;
    background-size: 120%;
  }

  &__content {
    padding: 1.5rem;
    transition: transform 0.5s;
    @media (max-width: 1370px) {
      padding: 1rem;
    }

    .tablet &,
    .mobile & {
      padding: 1rem;
    }
  }
  &__discover {
    @include overlay-m;

    border-radius: 59px;
    padding: 0.75rem toRem(24);
    color: var(--color-white);
    border: 2px solid var(--color-white);
    width: fit-content;
    background-color: var(--color-white-15);
    backdrop-filter: blur(12.5px);
    position: absolute;
    bottom: var(--cta-bottom, 1.5rem);
    right: var(--cta-right, 1.5rem);
    z-index: 1;

    .mobile &,
    .tablet & {
      position: initial;
      width: 100%;
      border: none;
      border-radius: 0rem 0 toRem(24) toRem(24);
      backdrop-filter: none;
      padding: 0.5rem 1rem 1rem 1rem;
    }
  }
}
</style>
